import http from "@/js/http";

function addQuestion(data: any) {
  const splitRe = /(?<=<td>)[\s\S]+?(?=<\/td>)/g;
  const titleRe = /(?<=【).+(?=】)/g;
  //const list = data.examination ?.match(splitRe).map((item: string) => item.replace(/<.+?>/g, "").replaceAll(/\n/g, "").trim());
  const list = data.examination ?.match(splitRe).map((item: string) =>item.replaceAll(/\n/g, "").trim())
  let currentState = "问题";
  const questionArr: any[] = [];
  if (list && list.length > 0) {
    list.forEach((item: string, index: number) => {
      const title = item.match(titleRe);
      if (title && title[0] && ["答案", "解析", "问题"].includes(title[0])) {
        currentState = title[0];
      } else {
        if (currentState === "问题") {
          if (/^[0-9]/.test(item)) {
            const itemList = item.split(/[．.]/);
            questionArr.push({
              index: itemList[0],
              question: itemList.slice(1).join(".").replaceAll("&nbsp;", " "),
              id: itemList[0],
              value: "",
              autoFocus: false,
              checkedValue: "",
            });
          } else if (/^[A-Z]/.test(item)) {
            const itemList = item.split(/[．.]/);
            questionArr[questionArr.length - 1][itemList[0].toLowerCase()] = itemList
              .slice(1)
              .join(".")
              .replaceAll("&nbsp;", " ");
          }
        } else if (currentState === "答案") {
          const itemList = item.split(/[．.]/);
          questionArr[+itemList[0] - 1]["success"] = itemList
            .slice(1)
            .join(".")
            .replaceAll(/\s|&nbsp;/g, "");
        } else if (currentState === "解析") {
          if (/^[0-9]/.test(item)) {
            const itemList = item.split(/[．.]/);
            questionArr[+itemList[0] - 1]["queType"] = itemList
              .slice(1)
              .join(".")
              .replaceAll("&nbsp;", " ");
            questionArr[+itemList[0] - 1]["analysis"] = list[index + 1].replaceAll("&nbsp;", " ");
          }
        }
      }
    });
  }
  data.question = questionArr;
  return data;
}

function addTextCn(data: any) {
  const re = /.+?(?=(长难句|语法点|重要语法点|重点语法点|语言点|重点语言点))/;
  const match = data.knowledge?.match(re);
  if (match) {
    data.textCn = `<p>${match[0]}</p>`;

    data.knowledge = data.knowledge
      .replace(re, "")
      .replaceAll("<p>", "<div>")
      .replaceAll("</p>", "</div>")
      .replace(/<div>\s+<\/div>/g, "")
      .replace(/\n+/g, "\n")
      .replaceAll("&nbsp;", " ");
  }
  return data;
}

export async function getArticleDetail(readingId: string, aptmId: string, token:string) {
  const res = await http.get(`/read/getEssayInfo?readingId=${readingId}&aptmId=${aptmId}`,{},token);
  let obj = {};
  if (res.data.code === 200) {
    res.data.data.btnDisabled = false
    obj = res.data.data;
    obj = addQuestion(obj);
    obj = addTextCn(obj);
  }
  return obj;
}
